
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140.29 123.76"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Home"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M111.49 36.92V9.39H92.73v10.78L70.14 0 0 62.65h15.59l54.55-48.72 54.56 48.72h15.59l-28.8-25.73z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M22.83 64.7v59.07h36.06V87.75H81.4v36.02h36.07V64.7L70.14 22.44 22.83 64.7z"}})])])])
          )
        }
      }
    